import PhoneNumber from "libphonenumber-js";

export const VALID_SUYOOL_PHONE_MESSAGE =
  "Phone Number entered is a valid suyool user";

export function normalizePhoneForValidation(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";

  const parsedPhoneNumber = PhoneNumber(rawValue, "LB");
  if (parsedPhoneNumber?.nationalNumber) {
    return String(parsedPhoneNumber.nationalNumber);
  }

  const digits = rawValue.replace(/\D/g, "");
  return digits.startsWith("961") ? digits.slice(3) : digits;
}

export function getPhoneValidationMessage(
  source,
  fallback = "Phone number is invalid.",
) {
  const data = source?.response?.data ?? source?.data ?? source;
  const payload = data?.Payload ?? data?.payload;
  const validationErrors = data?.errors
    ? Object.values(data.errors).flat().filter(Boolean)
    : [];

  return (
    payload?.Message ||
    payload?.message ||
    payload?.ErrorMessage ||
    payload?.errorMessage ||
    payload?.PopupDescription ||
    payload?.Description ||
    data?.PopupDescription ||
    data?.Message ||
    data?.message ||
    validationErrors[0] ||
    data?.title ||
    fallback
  );
}
